import qs from 'qs';
import { message } from 'antd';
import { colorCreateSignature } from './signature';
import { v4 as uuidv4 } from 'uuid';

import { goLogin } from './common';

import { BUSINESS_STATUS } from './common';
import { getColorBaseURL } from '@/util';
import { sgmCustomType } from '@/util/sgm';
import { getHost } from '@/util/host';
import { getLoginType } from '@/util/env';
import { getUrlParams } from '@/util/tools';

// import { LOCAL_STORAGE } from '@/constants/index';

let api = process.env.VUE_APP_BASE_COLOR_URL;
// 信息

// localStorage
const LOCAL_STORAGE = {
    MOCK_CACHE: 'mockCache', // mock
    API_CACHE: 'apiCache', // api环境
};

// 如果不是线上，并且设置了环境api
const apiCache = localStorage.getItem(LOCAL_STORAGE.API_CACHE);
if (
    process.env.VUE_APP_BASE_COLOR_ENV !== 'production' &&
    process.env.VUE_APP_BASE_COLOR_ENV !== 'gray' &&
    !!apiCache
) {
    api = apiCache;
}

export const COLOR = getHost().colorBaseUrl; // getColorBaseURL();
export const API_PRE_FIX = '/api';

/**
 * addRequestConfig
 * axios 请求拦截器方法
 * @param colorAPPID
 * @param config
 */
export const addRequestConfig = (colorAPPID, config = {}) => {
    // console.log('config======', config)

    // URL上默认参数
    const defaultParams = {
        partner: 'jd-dq',
        appid: colorAPPID,
        t: new Date().getTime(),
        version: '1.0',
        loginType: getLoginType(),
        client: 'PC',
    };
    // 请求参数 body 对象默认值
    // const defaultColorBodyParams = {
    //   requestId: new Date().getTime(),
    // };
    // 请求参数 body 对象默认值B商城
    const defaultColorBodyParams = {
        commonParam: {
            pid: 100, //产品线Id
            verticalCode: 'cn_retail_bmall', //判断业务身份
            ua: 1, //用户终端 PC:1
            language: 'zh', //国际化
            requestId: uuidv4(), //uuid，唯一标识
        },
        clientType: 'PC', //todo 目前职能来不及更改，后续删除
    };
    // url 其实是 functionId ， functionId 是color必传字段
    const { url: functionId } = config;

    // 判断是否为get
    let { method = 'get' } = config;
    method = method.toLowerCase();
    // FIX color会自动拦截，优先拦截query参数。 如果是POST，URL带query并且含有body参数，color直接吐query上的body值转发给后台，Form Data里的值根本不搭理
    const isMethodGet = method === 'get';
    // color网关的URL是固定值，这里将传入的url值设置为空
    config.url = '';

    config.transformRequest = [
        function (data) {
            // `transformRequest` 允许在向服务器发送前，修改请求数据
            // 只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
            // 判断POST请求 data 中是否 含有body ,body 为color的约定的业务参数
            // 调用不用写body, 保持统一：
            // 示例：axios.post(url, {a:1})
            data = Object.assign({}, defaultColorBodyParams, data);
            const requestPayLoad = {
                // POST 请求 data中，必须要 functionId 字段
                functionId: functionId.replace(/\//g, ''),
                body: JSON.stringify(data),
            };

            let requestData = Object.assign({}, defaultParams, requestPayLoad);
            // FIX 非get 请求 data 加参数
            requestData = colorCreateSignature(isMethodGet, requestData);
            return qs.stringify(requestData);
        },
    ];

    config.headers = {
        'Access-Control-Allow-Origin': '*',
        'content-type': 'application/x-www-form-urlencoded',
        'access-control-allow-headers': 'channel-xiniu',
        'x-requested-with': 'XMLHttpRequest',
    };
    // FIX 添加 query 参数
    const requestParams = Object.assign({}, defaultColorBodyParams, config.params);

    const requestQuery = {
        // 向 params 对象中添加 functionId 参数
        functionId,
        body: {
            ...requestParams,
        },
    };

    if (isMethodGet) {
        // config.headers = { 'content-type': 'application/json' }
        config.params = Object.assign({}, defaultParams, requestQuery);
        // FIX get 请求query 加参数
        config.params = colorCreateSignature(isMethodGet, config.params);
    }
    return config;
};

/**
 * 接口请求成功后，拦截返回值
 * @param response
 * @returns {Promise<never>}
 */
export const addResponseSuccess = (response = {}) => {
    const { data, config } = response;
    const { code = 0 } = data || {};
    const { params = {} } = config;
    // isShowMsg 是否需要提示，默认是走后端提示
    const { body = {} } = params;
    const { isShowMsg = true } = body;

    // 未登录，直接跳转
    if (BUSINESS_STATUS.NOT_LOGIN.includes(code)) {
        goLogin();
        return Promise.reject(data);
    } else if (BUSINESS_STATUS.NOT_HEADID.includes(code)) {
        window.location.href = 'weixin://dl/business/?t=Xai3myEiDmd';
        return Promise.reject(data);
    } else if (!BUSINESS_STATUS.SUCCESS.includes(code)) {
        isShowMsg &&
            message.error({
                content: data.errorDesc || data.message || data.msg || '服务异常，请稍后再试！',
            });
        let functionId = "";
        let requestParams = "";

        try {
            functionId = getUrlParams(config.data)?.functionId;
            requestParams = decodeURIComponent(getUrlParams(config.data)?.body);
        } catch (error) {}

        sgmCustomType(
            "warn",
            "30001",
            `${functionId}请求失败，入参：${requestParams}，接口返回：${JSON.stringify(
                data
            )}`
        );
        return Promise.reject(data);
    } else {
        return data;
    }
};

/**
 * 接口请求失败或者出现未知异常，给出错误提示信息
 * @param error
 * @returns {Promise<never>}
 */
export const addResponseError = (error = {}) => {
    console.log('======error==data======\n', error, error.response);
    const { status } = error.response || {};
    // 是否登录
    if (BUSINESS_STATUS.NOT_LOGIN.includes(status)) {
        goLogin();
        return Promise.reject(error.response);
    }

    error.message &&
        message.error({
            content: error.message || '未知错误！',
        });
    sgmCustomType("warn", "30001", `上报信息：${JSON.stringify(error)}`);
    return Promise.reject(error);
};
